<template>
   <div>
    <!-- Home Section -->
			<section id="home">
				<section id="xslider" class="contain">
					<div class="txp-banner">
						<img src="/assets/images/booking.png" alt="slidebg1" data-bgfit="cover"
							data-bgposition="left top" data-bgrepeat="no-repeat" style=" width: 100%;">
					</div>
				</section>
			</section>

			<section class="event-banner">
				<img src="/assets/images/event-main.png" alt="">
				<div class="event-name">Book your tour</div>
			</section>

			<section id="aa" class="contain ">
				<div class="inner">
					<div class="select_filter">
						<select ref="selectDay" class="select2 select_day">
							<option></option>
							<option value="16">June 16, 2018</option>
							<option value="17">June 17, 2018</option>
							<option value="18">June 18, 2018</option>
							<option value="19">June 19, 2018</option>
						</select>
						<select ref="selectTime" class="select2 select_time">
							<option></option>
							<option value="16">12AM/2PM</option>
							<option value="17">12AM/2PM</option>
							<option value="18">12AM/2PM</option>
							<option value="19">12AM/2PM</option>
						</select>
						<select ref="selectSeats" class="select2 select_seats">
							<option></option>
							<option value="16">June 16, 2018</option>
							<option value="17">June 17, 2018</option>
							<option value="18">June 18, 2018</option>
							<option value="19">June 19, 2018</option>
						</select>
					</div>

					<div class="filtered_data">
						<div class="filtered">
							<div id="filtered_day">
								<div class="filtered_day">
									<span>June 16, 2018</span>
								</div>
							</div>
							<div id="filtered_time">
								<div class="filtered_time">
									<span>12AM/2PM</span>
								</div>
							</div>
							<div id="filtered_seats">
								<div class="filtered_seats">
									<div class="filtered_seats_available_total">
										<div class="available">
											<span>Available</span>
											<span>100</span>
										</div>
										<div class="total">
											<span>Total</span>
											<span>00</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="filtered">
							<div id="filtered_day">
								
								<div class="filtered_day">
									<span>June 16, 2018</span>
								</div>

							</div>
							<div id="filtered_time">

								<div class="filtered_time">
									<span>12AM/2PM</span>
								</div>

							</div>
							<div id="filtered_seats">

								<div class="filtered_seats">
									<div class="filtered_seats_available_total">
										<div class="available">
											<span>Available</span>
											<span>100</span>
										</div>
										<div class="total">
											<span>Total</span>
											<span>00</span>
										</div>
									</div>
								</div>

							</div>
						</div>

						<div class="filtered">
							<div id="filtered_day">
								
								<div class="filtered_day">
									<span>June 16, 2018</span>
								</div>

							</div>
							<div id="filtered_time">

								<div class="filtered_time">
									<span>12AM/2PM</span>
								</div>

							</div>
							<div id="filtered_seats">

								<div class="filtered_seats">
									<div class="filtered_seats_available_total">
										<div class="available">
											<span>Available</span>
											<span>100</span>
										</div>
										<div class="total">
											<span>Total</span>
											<span>00</span>
										</div>
									</div>
								</div>

							</div>
						</div>

						<div class="filtered">
							<div id="filtered_day">
								
								<div class="filtered_day">
									<span>June 16, 2018</span>
								</div>

							</div>
							<div id="filtered_time">

								<div class="filtered_time">
									<span>12AM/2PM</span>
								</div>

							</div>
							<div id="filtered_seats">

								<div class="filtered_seats">
									<div class="filtered_seats_available_total">
										<div class="available">
											<span>Available</span>
											<span>100</span>
										</div>
										<div class="total">
											<span>Total</span>
											<span>00</span>
										</div>
									</div>
								</div>

							</div>
						</div>

						<button class="btn_x" type="submit"> Submit </button>
					</div>
				</div>
				<!-- End inner div -->
			</section>
   </div>
</template>
<script>
import '../../../public/assets/js/select2';

export default {
    data: () => ({
        baseUrl: window.location.origin,
    }),
    mounted() {
        // Initialize Select2 after the component is mounted
        this.initSelect2();
    },
    methods: {
        initSelect2() {
            // Use $refs to access the select elements
            const selectDay = this.$refs.selectDay;
            const selectTime = this.$refs.selectTime;
            const selectSeats = this.$refs.selectSeats;

            // Initialize Select2 on each select element
            $(selectDay).select2({
                placeholder: 'DATE',
                disabled: false,
            });

            $(selectTime).select2({
                placeholder: 'TIME',
                disabled: true,
            });

            $(selectSeats).select2({
                placeholder: 'Remaining seats',
                disabled: true,
            });

            // Additional logic for handling select events
            $(selectDay).on('select2:selecting', function (e) {
                console.log(e.params.args.data);
                $(selectTime).prop('disabled', false);
            });

            $(selectTime).on('select2:selecting', function (e) {
                console.log(e.params.args.data);
                $(selectSeats).prop('disabled', false);
            });

            $(selectSeats).on('select2:selecting', function (e) {
                console.log(e.params.args.data);
            });
        }
    }
}
</script>

<style scoped>
@import '../../../public/assets/css/new-conf-style.css';
@import '../../../public/assets/css/select2.css';

</style>